// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Dialog_wrapper__2pyQI"};